var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.90918C4.48615 0.90918 0 5.33893 0 10.7835C0 16.228 4.48615 20.6577 10 20.6577C15.5138 20.6577 20 16.228 20 10.7835C20 5.33893 15.5138 0.90918 10 0.90918ZM10 2.4283C14.6823 2.4283 18.4615 6.16002 18.4615 10.7835C18.4615 15.4069 14.6823 19.1386 10 19.1386C5.31769 19.1386 1.53846 15.4069 1.53846 10.7835C1.53846 6.16002 5.31769 2.4283 10 2.4283ZM9.23077 6.2261V10.0239H5.38462V11.543H9.23077V15.3408H10.7692V11.543H14.6154V10.0239H10.7692V6.2261H9.23077Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.e782f510980baa6aaa3dbd296720fc97.svg";
export { ForwardRef as ReactComponent };